import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup, List } from "devextreme-react";
import { lastStep, nextStep, setDataForms, doUploadFile, doDeleteSingleFile, setStep } from "../../actions";

import helper from "../../../../../../../helpers/validaciones";
import FileUploaderField from "../../../../../../Shared/fields/FileUploaderField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import NumberField from "../../../../../../Shared/fields/NumberField";

const motivosAusencia = [
  "Ausencia sin justificacion",
  "Contrato a plazo fijo",
  "Huelga legal",
  "Licencia medica pagada",
  "Licencia medica rechazada",
  "Permiso sin goce de sueldo",
]


const maxFileSize = process.env.REACT_APP_MAX_FILE_FIELD_SIZE_UPLOAD_IN_BM * 1000000


class InfoLaboral extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      openMotivoMes1: false,
      openMotivoMes2: false,
      openMotivoMes3: false,
    };

    this.topRef = React.createRef();
    if (!props.jsonData.formInfoLaboral) {
      props.dispatch(setDataForms({
        ...props.jsonData,
        formInfoLaboral: {},
      }));
    }
  }
  componentDidMount() {
    const jsonData = { ...this.props.jsonData };
    jsonData.step1Complete = true;
    jsonData.step2Complete = true;
    jsonData.step3Complete = false;
    jsonData.step4Complete = false;
    this.props.dispatch(setDataForms(jsonData));

    this.setState({
      openMotivoMes1: this.checkDiasTrabajados(jsonData.formInfoLaboral.DiasTrabajadosMesUno),
      openMotivoMes2: this.checkDiasTrabajados(jsonData.formInfoLaboral.DiasTrabajadosMesDos),
      openMotivoMes3: this.checkDiasTrabajados(jsonData.formInfoLaboral.DiasTrabajadosMesTres),
    })
  }
  checkDiasTrabajados = (dias) => {
    return dias < 27;
  }
  handleBack = () => {
    this.topRef.current.scrollIntoView();
    const step = 1;
    this.props.dispatch(setStep(step));
    this.props.dispatch(lastStep());
  }
  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      this.topRef.current.scrollIntoView();
      this.props.onSave();
      const step = 3;
      this.props.dispatch(setStep(step));
      this.props.dispatch(nextStep());
    }
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };
    if (e.value === NaN) {
      jsonData.formInfoLaboral[e.element.id] = 0;
    } else {
      jsonData.formInfoLaboral[e.element.id] = e.value;
    }

    switch (e.element.id) {
      case "DiasTrabajadosMesUno": {
        this.setState({
          openMotivoMes1: this.checkDiasTrabajados(e.value),
        });

        break;
      }
      case "DiasTrabajadosMesDos": {
        this.setState({
          openMotivoMes2: this.checkDiasTrabajados(e.value),
        });
        break;
      }
      case "DiasTrabajadosMesTres": {
        this.setState({
          openMotivoMes3: this.checkDiasTrabajados(e.value),
        });

        break;
      }
      default:
        break;
    }


    this.props.dispatch(setDataForms(jsonData));
  }

  handeChangeDctos = (e) => {
    const jsonData = { ...this.props.jsonData };

    const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });
    jsonData.container = `${rutWorker}${this.props.userData.RUT}${jsonData.idFinancialBenefit}`;
    const data = {};
    data.rutTrabajador = rutWorker;
    data.rutUsuario = this.props.userData.RUT;
    data.idPrestacion = jsonData.idFinancialBenefit;
    switch (e.element.id) {
      case "adjuntoLiquidacionMesUno": {
        if (e.value) {
          const archivo = e.value[0];

          data.files = archivo;
          data.type = "liq1";
          if (jsonData.formInfoLaboral.hasOwnProperty("adjuntoLiquidacionMesUno") === true) {
            this.props.dispatch(doDeleteSingleFile({
              rutTrabajador: rutWorker,
              rutUsuario: this.props.userData.RUT,
              idPrestacion: jsonData.idFinancialBenefit,
              NombreArchivo: jsonData.formInfoLaboral.adjuntoLiquidacionMesUno,
            }, false));
          }
          this.props.dispatch(doUploadFile(data, () => {
            jsonData.formInfoLaboral.adjuntoLiquidacionMesUno = archivo.name;
          }));
        }
        break;
      }
      case "adjuntoJustificacionMesUno": {
        const archivo = e.value[0];
        data.files = archivo;
        data.type = "licencia1";
        this.props.dispatch(doUploadFile(data, () => {
          if (jsonData.formInfoLaboral.hasOwnProperty("adjuntoJustificacionMesUno") === false || jsonData.formInfoLaboral.adjuntoJustificacionMesUno === null) {
            const justificaciones = [];
            justificaciones.push(archivo.name);
            jsonData.formInfoLaboral.adjuntoJustificacionMesUno = justificaciones;
          } else {
            jsonData.formInfoLaboral.adjuntoJustificacionMesUno.push(archivo.name);
          }
        }));
        break;
      }

      case "adjuntoLiquidacionMesDos": {
        if (e.value) {
          const archivo = e.value[0];
          data.files = archivo;
          data.type = "liq2";
          if (jsonData.formInfoLaboral.hasOwnProperty("adjuntoLiquidacionMesDos") === true) {
            this.props.dispatch(doDeleteSingleFile({
              rutTrabajador: rutWorker,
              rutUsuario: this.props.userData.RUT,
              idPrestacion: jsonData.idFinancialBenefit,
              NombreArchivo: jsonData.formInfoLaboral.adjuntoLiquidacionMesDos,
            }, false));
          }
          this.props.dispatch(doUploadFile(data, () => {
            jsonData.formInfoLaboral.adjuntoLiquidacionMesDos = archivo.name;
          }));
        }
        break;
      }
      case "adjuntoJustificacionMesDos": {
        const archivo = e.value[0];
        data.files = archivo;
        data.type = "licencia2";
        this.props.dispatch(doUploadFile(data, () => {
          if (jsonData.formInfoLaboral.hasOwnProperty("adjuntoJustificacionMesDos") === false || jsonData.formInfoLaboral.adjuntoJustificacionMesDos === null) {
            const justificaciones = [];
            justificaciones.push(archivo.name);
            jsonData.formInfoLaboral.adjuntoJustificacionMesDos = justificaciones;
          } else {
            jsonData.formInfoLaboral.adjuntoJustificacionMesDos.push(archivo.name);
          }
        }));
        break;
      }
      case "adjuntoLiquidacionMesTres": {
        if (e.value) {
          const archivo = e.value[0];
          data.files = archivo;
          data.type = "liq3";
          if (jsonData.formInfoLaboral.hasOwnProperty("adjuntoLiquidacionMesTres") === true) {
            this.props.dispatch(doDeleteSingleFile({
              rutTrabajador: rutWorker,
              rutUsuario: this.props.userData.RUT,
              idPrestacion: jsonData.idFinancialBenefit,
              NombreArchivo: jsonData.formInfoLaboral.adjuntoLiquidacionMesTres,
            }, false));
          }
          this.props.dispatch(doUploadFile(data, () => {
            jsonData.formInfoLaboral.adjuntoLiquidacionMesTres = archivo.name;
          }));
        }
        break;
      }
      case "adjuntoJustificacionMesTres": {
        const archivo = e.value[0];
        data.files = archivo;
        data.type = "licencia3";
        this.props.dispatch(doUploadFile(data, () => {
          if (jsonData.formInfoLaboral.hasOwnProperty("adjuntoJustificacionMesTres") === false || jsonData.formInfoLaboral.adjuntoJustificacionMesTres === null) {
            const justificaciones = [];
            justificaciones.push(archivo.name);
            jsonData.formInfoLaboral.adjuntoJustificacionMesTres = justificaciones;
          } else {
            jsonData.formInfoLaboral.adjuntoJustificacionMesTres.push(archivo.name);
          }
        }));
        break;
      }


      default:
        break;
    }

    this.props.dispatch(setDataForms(jsonData));
  }

  eliminoDcto(dcto, property) {
    const jsonData = { ...this.props.jsonData };
    const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });
    jsonData.container = `${rutWorker}${this.props.userData.RUT}${jsonData.idFinancialBenefit}`;

    switch (property) {
      case "adjuntoJustificacionMesUno": {
        jsonData.formInfoLaboral.adjuntoJustificacionMesUno = jsonData.formInfoLaboral.adjuntoJustificacionMesUno.filter((item) => item !== dcto);
        break;
      }
      case "adjuntoJustificacionMesDos": {
        jsonData.formInfoLaboral.adjuntoJustificacionMesDos = jsonData.formInfoLaboral.adjuntoJustificacionMesDos.filter((item) => item !== dcto);
        break;
      }
      case "adjuntoJustificacionMesTres": {
        jsonData.formInfoLaboral.adjuntoJustificacionMesTres = jsonData.formInfoLaboral.adjuntoJustificacionMesTres.filter((item) => item !== dcto);
        break;
      }
      default:
        jsonData.formInfoLaboral[property] = null;
        break;
    }

    this.props.dispatch(doDeleteSingleFile({
      rutTrabajador: rutWorker,
      rutUsuario: this.props.userData.RUT,
      idPrestacion: jsonData.idFinancialBenefit,
      NombreArchivo: dcto,
    }, true));
    this.props.dispatch(setDataForms(jsonData));
  }

  renderDocument = (nmbDcto, property, titulo) => {
    let list = [];
    if (Array.isArray(nmbDcto)) {
      nmbDcto.forEach((d) => {
        list.push({ Nombre: d });
      });
    } else if (typeof (nmbDcto) === "string") {
      list.push({ Nombre: nmbDcto })
    }
    return (

      <React.Fragment>
        <div style={{ marginBottom: 10, marginTop: 10 }}>
          <span className="title">{titulo}</span>
          <List
            className="draf-document-list"
            scrollByContent
            selectedIndex={2}
            noDataText="Sin documentos"
            items={list}
            itemComponent={(item) => (
              <div className="list-document-wrapper">
                <div className="text">
                  <span className="text"><i className="material-icons" style={{ fontSize: 10 }} > attach_file </i> {item.Nombre}</span>
                </div>

                <div style={{ paddingLeft: 5 }} >
                  <Button
                    stylingMode="text"
                    className="material-icons"
                    style={{
                      backgroundColor: "Transparent",
                      border: "none",
                    }}
                    key={`${item.Nombre}_eliminar`}
                    onClick={() => this.eliminoDcto(item.Nombre, property)}
                  >
                    <i className="material-icons" style={{ fontSize: 10 }} > delete </i>
                  </Button>
                </div>


              </div>
            )}
          />
        </div >
      </React.Fragment>
    );
  }

  render() {
    const form = { ...this.props.jsonData.formInfoLaboral };
    const monthsDisplay = this.props.jsonData.monthsDisplay;


    return (
      <ValidationGroup>

        <div className="col-12 newDenuncia-title" ref={this.topRef}>
          <h2>Información laboral</h2>
          <p>Completa los datos para pasar a la siguiente sección</p>
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">{monthsDisplay[0]}</h4>
          <div className="inline-file-upload">
            <NumberField
              label={`Dias Trabajados en ${monthsDisplay[0]}`}
              id="DiasTrabajadosMesUno"
              required
              min={0}
              showSpinButtons
              max={31}
              value={form.DiasTrabajadosMesUno}
              onChange={this.handleChange}
            />

            <FileUploaderField
              id="adjuntoLiquidacionMesUno"
              text="Adjuntar Liquidación"
              multiple={false}
              formats="application/pdf"
              maxFileSize={maxFileSize}
              uploadMode="useForm"
              validar={form.adjuntoLiquidacionMesUno == null}
              onChange={this.handeChangeDctos}
            />
          </div>
          {this.state.openMotivoMes1 ?
            <React.Fragment>
              <div className="inline-file-upload">
                <SelectField
                  label={`Motivo de ausencia ${monthsDisplay[0]}`}
                  id="motivoAusenciaMesUno"
                  required
                  onValueChanged={this.handleChange}
                  value={form && form.motivoAusenciaMesUno ? form.motivoAusenciaMesUno : null}
                  items={motivosAusencia}
                />

                <FileUploaderField
                  id="adjuntoJustificacionMesUno"
                  formats="application/pdf"
                  maxFileSize={maxFileSize}
                  disabled={form.motivoAusenciaMesUno == null}
                  text="Adjuntar justificación"
                  multiple={false}
                  uploadMode="useForm"
                  validar={form.adjuntoJustificacionMesUno == null}
                  onChange={this.handeChangeDctos}
                />
              </div>
              {
                form.adjuntoJustificacionMesUno && form.adjuntoJustificacionMesUno.length > 0 && this.renderDocument(form.adjuntoJustificacionMesUno, "adjuntoJustificacionMesUno", `Documentos justificación de ${monthsDisplay[0]}`)
              }
            </React.Fragment>
            : <div></div>
          }
          {
            form.adjuntoLiquidacionMesUno && this.renderDocument(form.adjuntoLiquidacionMesUno, "adjuntoLiquidacionMesUno", `Liquidación de ${monthsDisplay[0]}`)
          }
        </div>
        {monthsDisplay.length >= 2 ?

          <div className="col-12">
            <h4 className="newDenuncia-subtitle">{monthsDisplay[1]}</h4>
            <div className="inline-file-upload">
              <NumberField
                label={`Dias Trabajados en ${monthsDisplay[1]}`}
                id="DiasTrabajadosMesDos"
                max={31}
                required
                min={0}
                showSpinButtons
                value={form.DiasTrabajadosMesDos}
                onChange={this.handleChange}
              />
              <FileUploaderField
                id="adjuntoLiquidacionMesDos"
                text="Adjuntar Liquidación"
                multiple={false}
                formats="application/pdf"
                maxFileSize={maxFileSize}
                uploadMode="useForm"
                validar={form.adjuntoLiquidacionMesDos == null}
                onChange={this.handeChangeDctos}
              />
            </div>
            {this.state.openMotivoMes2 ?
              <React.Fragment>
                <div className="inline-file-upload">
                  <SelectField
                    label={`Motivo de ausencia ${monthsDisplay[1]}`}
                    id="motivoAusenciaMesDos"
                    required
                    onValueChanged={this.handleChange}
                    value={form && form.motivoAusenciaMesDos ? form.motivoAusenciaMesDos : null}
                    items={motivosAusencia}
                  />

                  <FileUploaderField
                    id="adjuntoJustificacionMesDos"
                    text="Adjuntar justificación"
                    multiple={false}
                    formats="application/pdf"
                    maxFileSize={maxFileSize}
                    disabled={form.motivoAusenciaMesDos == null}
                    uploadMode="useForm"
                    validar={form.adjuntoJustificacionMesDos == null}
                    onChange={this.handeChangeDctos}
                  />
                </div>
                {
                  form.adjuntoJustificacionMesDos && form.adjuntoJustificacionMesDos.length > 0 && this.renderDocument(form.adjuntoJustificacionMesDos, "adjuntoJustificacionMesDos", `Documentos justificación de ${monthsDisplay[1]}`)
                }
              </React.Fragment>
              :
              ""

            }
            {
              form.adjuntoLiquidacionMesDos && this.renderDocument(form.adjuntoLiquidacionMesDos, "adjuntoLiquidacionMesDos", `Liquidación de ${monthsDisplay[1]}`)
            }
          </div>
          : <div></div>
        }
        {monthsDisplay.length === 3 ?

          <div className="col-12">
            <h4 className="newDenuncia-subtitle">{monthsDisplay[2]}</h4>
            <div className="inline-file-upload">
              <NumberField
                label={`Dias Trabajados en ${monthsDisplay[2]}`}
                id="DiasTrabajadosMesTres"
                required
                min={0}
                max={31}
                showSpinButtons
                value={form.DiasTrabajadosMesTres}
                onChange={this.handleChange}
              />

              <FileUploaderField
                id="adjuntoLiquidacionMesTres"
                text="Adjuntar Liquidación"
                multiple={false}
                uploadMode="useForm"
                formats="application/pdf"
                maxFileSize={maxFileSize}
                validar={form.adjuntoLiquidacionMesTres == null}
                onChange={this.handeChangeDctos}
              />
            </div>
            {this.state.openMotivoMes3 ?
              <React.Fragment>
                <div className="inline-file-upload">

                  <SelectField
                    label={`Motivo de ausencia ${monthsDisplay[2]}`}
                    id="motivoAusenciaMesTres"
                    required
                    onValueChanged={this.handleChange}
                    value={form && form.motivoAusenciaMesTres ? form.motivoAusenciaMesTres : null}
                    items={motivosAusencia}
                  />

                  <FileUploaderField
                    id="adjuntoJustificacionMesTres"
                    text="Adjuntar justificación"
                    multiple={false}
                    formats="application/pdf"
                    maxFileSize={maxFileSize}
                    disabled={form.motivoAusenciaMesTres == null}
                    uploadMode="useForm"
                    validar={form.adjuntoJustificacionMesTres == null}
                    onChange={this.handeChangeDctos}
                  />
                </div>
                {
                  form.adjuntoJustificacionMesTres && form.adjuntoJustificacionMesTres.length > 0 && this.renderDocument(form.adjuntoJustificacionMesTres, "adjuntoJustificacionMesTres", `Documentos justificación de ${monthsDisplay[2]}`)
                }
              </React.Fragment>
              :
              <div></div>

            }

            {
              form.adjuntoLiquidacionMesTres && this.renderDocument(form.adjuntoLiquidacionMesTres, "adjuntoLiquidacionMesTres", `Liquidación de ${monthsDisplay[2]}`)
            }
          </div>
          :
          <div></div>
        }


        <div className="col-12">
          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />
          <Button
            text="Siguiente"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />
        </div>
      </ValidationGroup>

    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.prestacionesEmpresa.jsonData,
  userData: state.global.userData,
  listaDocumentosIngresados: state.prestacionesEmpresa.listaDocumentosIngresados,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoLaboral);
